/**
 * Floating action / speed-dial placement (Material Design FAB margins).
 * Mobile: 16dp from edges; desktop: 24dp. Always add safe-area insets.
 * Optional --apt-bottom-chrome-height clears sticky bottom bars when set.
 */

export const APT_BOTTOM_CHROME_HEIGHT_CSS_VAR = '--apt-bottom-chrome-height';

/** Material Design default FAB margin on phone-sized viewports. */
export const FAB_EDGE_MARGIN_MOBILE_PX = 16;

/** Slightly larger margin on desktop / tablet+ for visual balance. */
export const FAB_EDGE_MARGIN_DESKTOP_PX = 24;

export function fabBottomCss(isMobile: boolean, extraPx = 0): string {
  const edge = isMobile ? FAB_EDGE_MARGIN_MOBILE_PX : FAB_EDGE_MARGIN_DESKTOP_PX;
  const extra = Math.max(0, Math.round(extraPx));
  const extraTerm = extra > 0 ? ` + ${extra}px` : '';
  return `calc(${edge}px + var(${APT_BOTTOM_CHROME_HEIGHT_CSS_VAR}, 0px) + env(safe-area-inset-bottom, 0px)${extraTerm})`;
}

export function fabRightCss(isMobile: boolean): string {
  const edge = isMobile ? FAB_EDGE_MARGIN_MOBILE_PX : FAB_EDGE_MARGIN_DESKTOP_PX;
  return `calc(${edge}px + env(safe-area-inset-right, 0px))`;
}

export function setBottomChromeHeightPx(heightPx: number): void {
  if (typeof document === 'undefined') return;
  const h = Math.max(0, Math.round(heightPx));
  if (h <= 0) {
    document.documentElement.style.removeProperty(APT_BOTTOM_CHROME_HEIGHT_CSS_VAR);
    return;
  }
  document.documentElement.style.setProperty(APT_BOTTOM_CHROME_HEIGHT_CSS_VAR, `${h}px`);
}

export function clearBottomChromeHeight(): void {
  if (typeof document === 'undefined') return;
  document.documentElement.style.removeProperty(APT_BOTTOM_CHROME_HEIGHT_CSS_VAR);
}
